import { BaseModel } from './base.model';
import { Json } from '../modules';
import { ValidateModel } from './validate.model';

export class ArtistModel extends BaseModel {
  @Json('title')
  public title: string = undefined;

  @Json('image')
  public image: string = undefined;

  @Json('countAlbum')
  public countAlbum: number = 0;

  @Json('countSong')
  public countSong: number = 0;

  constructor() {
    super();
    this.validateRules = new ValidateModel();
    this.initValidateRules();
  }

  public initValidateRules(): ValidateModel {
    return this.getRules();
  }
}
